export default __webpack_public_path__ + "static/media/background-home.d429a6b5.jpeg";